import { useState, useMemo } from 'react';
import { LoadingSpinner, AudioPlayerV2 } from '@lib/common';
import { useSectionEditing, useSectionForm, useSectionAudio } from './hooks';
import { CardLayout, CardTitle, CardDescription, CardActions, StyledCardContainer, StyledAudioWrapper } from '../shared';
import { TextLinkButton } from '@lib/common';
import { CloseOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionV2Preview = function SectionV2Preview(_ref) {
  var _audioFile$rule3, _audioFile$rule3$numb, _audioFile$rule5, _audioFile$rule5$numb, _section$id, _audioFile$rule$isAll, _audioFile$rule6, _audioFile$rule$allow, _audioFile$rule7, _audioFile$rule$isAut, _audioFile$rule8;

  var section = _ref.section,
      sectionLabel = _ref.sectionLabel,
      sectionDisplayIndex = _ref.sectionDisplayIndex,
      isOnlyRemainingSection = _ref.isOnlyRemainingSection,
      _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly,
      isFocusedSection = _ref.isFocusedSection,
      onSelectedSection = _ref.onSelectedSection,
      handleGetPositionElement = _ref.handleGetPositionElement,
      onCreateSection = _ref.onCreateSection,
      onEditSection = _ref.onEditSection,
      onDeleteSection = _ref.onDeleteSection,
      PinIcon = _ref.PinIcon,
      onPinSection = _ref.onPinSection,
      pinnedSectionId = _ref.pinnedSectionId,
      onCancelPin = _ref.onCancelPin,
      audioStats = _ref.audioStats,
      audioPlayerLabels = _ref.audioPlayerLabels,
      onTrackAudioPlay = _ref.onTrackAudioPlay,
      isAiMode = _ref.isAiMode,
      onMention = _ref.onMention,
      _ref$isShowingExtendO = _ref.isShowingExtendOrCollapse,
      isShowingExtendOrCollapse = _ref$isShowingExtendO === void 0 ? false : _ref$isShowingExtendO,
      _ref$hidePinButton = _ref.hidePinButton,
      hidePinButton = _ref$hidePinButton === void 0 ? false : _ref$hidePinButton,
      _ref$titleVariant = _ref.titleVariant,
      titleVariant = _ref$titleVariant === void 0 ? 'default' : _ref$titleVariant,
      _ref$disableAudioRule = _ref.disableAudioRules,
      disableAudioRules = _ref$disableAudioRule === void 0 ? false : _ref$disableAudioRule,
      _ref$disableAudioPlay = _ref.disableAudioPlayer,
      disableAudioPlayer = _ref$disableAudioPlay === void 0 ? false : _ref$disableAudioPlay;

  var _useState = useState(),
      openPopoverSectionId = _useState[0],
      setOpenPopoverSectionId = _useState[1];

  var _useState2 = useState(false),
      isSectionEditMode = _useState2[0],
      setIsSectionEditMode = _useState2[1]; // Hooks


  var editing = useSectionEditing({
    section: section,
    sectionLabel: sectionLabel,
    readonly: true,
    onUpdateSection: undefined // Preview mode doesn't update

  });
  var form = useSectionForm({
    section: section,
    localTitle: editing.localTitle,
    localDescription: editing.localDescription,
    sectionLabel: sectionLabel,
    onUpdateSection: undefined
  });

  var _useSectionAudio = useSectionAudio({
    section: section
  }),
      audioFile = _useSectionAudio.audioFile;

  var shouldDisableAudioRules = disableAudioRules; // Calculate audio stats for this section (similar to submission-section)

  var audioStatsForSection = useMemo(function () {
    return audioStats === null || audioStats === void 0 ? void 0 : audioStats.find(function (stat) {
      return stat.audioFileId === (audioFile === null || audioFile === void 0 ? void 0 : audioFile.id.toString());
    });
  }, [audioStats, audioFile === null || audioFile === void 0 ? void 0 : audioFile.id]);
  var numberOfReplaysRemaining = useMemo(function () {
    var _audioFile$rule, _audioFile$rule$numbe, _audioFile$rule$numbe2, _audioFile$rule2, _audioFile$rule2$numb;

    if (shouldDisableAudioRules) return -1;
    var ruleVal = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule = audioFile.rule) === null || _audioFile$rule === void 0 ? void 0 : (_audioFile$rule$numbe = _audioFile$rule.numberOfReplays) === null || _audioFile$rule$numbe === void 0 ? void 0 : _audioFile$rule$numbe.value;
    if (ruleVal === -1) return -1;

    if (ruleVal != null && audioStats != null) {
      var _audioStatsForSection;

      var used = audioStatsForSection ? ((_audioStatsForSection = audioStatsForSection.numberOfReplays) !== null && _audioStatsForSection !== void 0 ? _audioStatsForSection : 0) + 1 : 0;
      return Math.max(0, ruleVal - used);
    }

    return (_audioFile$rule$numbe2 = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule2 = audioFile.rule) === null || _audioFile$rule2 === void 0 ? void 0 : (_audioFile$rule2$numb = _audioFile$rule2.numberOfReplays) === null || _audioFile$rule2$numb === void 0 ? void 0 : _audioFile$rule2$numb.value) !== null && _audioFile$rule$numbe2 !== void 0 ? _audioFile$rule$numbe2 : 1;
  }, [shouldDisableAudioRules, audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule3 = audioFile.rule) === null || _audioFile$rule3 === void 0 ? void 0 : (_audioFile$rule3$numb = _audioFile$rule3.numberOfReplays) === null || _audioFile$rule3$numb === void 0 ? void 0 : _audioFile$rule3$numb.value, audioStats, audioStatsForSection]);
  /** Parent passes `audioPlayStats` from submission so reload keeps the same budget as the server. */

  var replayBudgetFromServer = useMemo(function () {
    var _audioFile$rule4, _audioFile$rule4$numb;

    if (shouldDisableAudioRules) return false;
    var v = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule4 = audioFile.rule) === null || _audioFile$rule4 === void 0 ? void 0 : (_audioFile$rule4$numb = _audioFile$rule4.numberOfReplays) === null || _audioFile$rule4$numb === void 0 ? void 0 : _audioFile$rule4$numb.value;
    return v != null && v !== -1 && audioStats != null;
  }, [shouldDisableAudioRules, audioStats, audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule5 = audioFile.rule) === null || _audioFile$rule5 === void 0 ? void 0 : (_audioFile$rule5$numb = _audioFile$rule5.numberOfReplays) === null || _audioFile$rule5$numb === void 0 ? void 0 : _audioFile$rule5$numb.value]);
  var sectionTagLabel = useMemo(function () {
    var _sectionLabel$section;

    var base = (_sectionLabel$section = sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.section) !== null && _sectionLabel$section !== void 0 ? _sectionLabel$section : 'SECTION';

    if (typeof sectionDisplayIndex === 'number' && sectionDisplayIndex >= 0) {
      return "".concat(base, " ").concat(sectionDisplayIndex + 1);
    }

    return base;
  }, [sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.section, sectionDisplayIndex]);

  if (!section) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  } // Get section ID


  var sectionId = (section === null || section === void 0 ? void 0 : (_section$id = section.id) === null || _section$id === void 0 ? void 0 : _section$id.toString()) || '';
  var isPinned = pinnedSectionId === sectionId;

  var renderPinButton = function renderPinButton() {
    if (hidePinButton) return null; // Show pin button only in readonly mode (for responder)

    if (!readonly || !PinIcon || !onPinSection) return null;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: isPinned ? /*#__PURE__*/_jsx(TextLinkButton, {
        icon: /*#__PURE__*/_jsx(CloseOutlined, {}),
        onClick: function onClick() {
          return onCancelPin === null || onCancelPin === void 0 ? void 0 : onCancelPin();
        }
      }) : /*#__PURE__*/_jsx(TextLinkButton, {
        icon: PinIcon,
        onClick: function onClick() {
          return onPinSection(sectionId);
        }
      })
    });
  };

  var handleEditClick = function handleEditClick() {
    // Call onEditSection to notify parent to switch to edit mode
    if (onEditSection) {
      onEditSection(sectionId);
    }
  };

  var handleSave = function handleSave() {
    editing.handleDescriptionSave();
    setIsSectionEditMode(false);
  };

  var handleCancel = function handleCancel() {
    setIsSectionEditMode(false);
    editing.handleDescriptionCancel();
  };

  return /*#__PURE__*/_jsxs(CardLayout, {
    isFocused: isFocusedSection,
    onClick: function onClick() {
      return onSelectedSection === null || onSelectedSection === void 0 ? void 0 : onSelectedSection(sectionId);
    },
    sectionId: sectionId,
    formProps: {
      form: form.form,
      name: 'section',
      initialValues: form.initialValues,
      onFieldsChange: form.onFieldsChange
    },
    onGetPositionElement: handleGetPositionElement,
    children: [/*#__PURE__*/_jsxs(StyledCardContainer, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        tagLabel: sectionTagLabel,
        title: editing.localTitle,
        titleVariant: titleVariant,
        isEditing: isSectionEditMode,
        isReadonly: readonly,
        placeholder: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.placeholderSectionTitle,
        onChange: function onChange(e) {
          return editing.handleTitleChange(e);
        },
        onBlur: editing.handleTitleBlur,
        onFocus: editing.handleTitleFocus,
        onKeyDown: editing.handleTitleKeyDown,
        onClick: editing.handleTitleFocus,
        autoFocus: isSectionEditMode,
        pinButton: renderPinButton()
      }), !readonly && /*#__PURE__*/_jsx(CardActions, {
        isOnlyRemainingSection: isOnlyRemainingSection,
        onEdit: function onEdit(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          handleEditClick();
        },
        onDelete: function onDelete(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          onDeleteSection === null || onDeleteSection === void 0 ? void 0 : onDeleteSection();
        },
        openPopoverId: openPopoverSectionId,
        onPopoverChange: setOpenPopoverSectionId,
        sectionId: sectionId,
        addSectionAboveLabel: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.addSectionAbove,
        addSectionBelowLabel: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.addSectionBelow,
        onCreateSectionAbove: function onCreateSectionAbove() {
          onCreateSection(section.previousSectionId);
          setOpenPopoverSectionId('');
        },
        onCreateSectionBelow: function onCreateSectionBelow() {
          onCreateSection(sectionId);
          setOpenPopoverSectionId('');
        },
        actions: ['edit', 'mention', 'delete'],
        isAiMode: isAiMode,
        onMention: onMention
      })]
    }), (audioFile === null || audioFile === void 0 ? void 0 : audioFile.url) && /*#__PURE__*/_jsx(StyledAudioWrapper, {
      children: /*#__PURE__*/_jsx(AudioPlayerV2, {
        source: audioFile.url,
        audioId: "section-".concat(sectionId),
        disabled: disableAudioPlayer,
        isInteractionLocked: disableAudioPlayer,
        audioPlayerConfig: {
          isAllowedToReplay: shouldDisableAudioRules ? true : (_audioFile$rule$isAll = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule6 = audioFile.rule) === null || _audioFile$rule6 === void 0 ? void 0 : _audioFile$rule6.isAllowedToReplay) !== null && _audioFile$rule$isAll !== void 0 ? _audioFile$rule$isAll : false,
          isAllowedToPause: shouldDisableAudioRules ? true : (_audioFile$rule$allow = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule7 = audioFile.rule) === null || _audioFile$rule7 === void 0 ? void 0 : _audioFile$rule7.allowingToPauseAndStop) !== null && _audioFile$rule$allow !== void 0 ? _audioFile$rule$allow : true,
          isAutoPlay: shouldDisableAudioRules ? false : (_audioFile$rule$isAut = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule8 = audioFile.rule) === null || _audioFile$rule8 === void 0 ? void 0 : _audioFile$rule8.isAutoPlay) !== null && _audioFile$rule$isAut !== void 0 ? _audioFile$rule$isAut : false,
          numberOfReplays: numberOfReplaysRemaining,
          decrementReplaysOnEnded: !replayBudgetFromServer,
          onTrackAudioPlay: onTrackAudioPlay
        },
        labels: audioPlayerLabels
      })
    }, "section-audio-".concat(sectionId)), /*#__PURE__*/_jsx(CardDescription, {
      description: editing.localDescription,
      isEditing: isSectionEditMode,
      isReadonly: readonly,
      placeholder: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.placeholderSectionDescription,
      onChange: editing.handleDescriptionChange,
      onSave: handleSave,
      onCancel: handleCancel,
      saveLabel: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.save,
      cancelLabel: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.cancel,
      isShowingExtendOrCollapse: isShowingExtendOrCollapse
    })]
  });
};